import ColorPicker from "@/pages/design/components/ColorPicker";
import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import InputBar from "@/pages/design/components/InputBar";
import FileUpload from "@/pages/design/components/FileUpload";
export default {
  i18n: require('../../design_i18n'),
  components: {
    ColorPicker: ColorPicker,
    Card: Card,
    CardItem: CardItem,
    InputBar: InputBar,
    FileUpload: FileUpload
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  computed: {
    list: function list() {
      if (!this.value.logoPath) return [];
      return [this.$store.state.design.imgHost + this.value.logoPath];
    }
  },
  methods: {
    handleClearImg: function handleClearImg() {
      this.value.logoPath = '';
    },
    handleLogoSuccess: function handleLogoSuccess(val) {
      this.value.logoPath = val;
    }
  }
};